<ng-container *ngIf="viewModel$ | async as vm">
  <div class="options-grid">
    <button
      *ngFor="let option of vm.options"
      class="option-card"
      [class.selected]="option.selected"
      (click)="store.dispatch(actions.optionClicked({ value: option.value }))"
    >
      <i *ngIf="option.icon" class="pi option-icon" [ngClass]="option.icon"></i>
      <span *ngIf="!option.icon && option.glyph" class="option-glyph">{{
        option.glyph
      }}</span>
      <span *ngIf="option.unit" class="option-unit">{{ option.unit }}</span>
      <span class="option-label">{{ option.label }}</span>
    </button>
  </div>

  <div class="wizard-footer" *ngIf="vm.showBackButton">
    <p-button
      label="Back"
      icon="pi pi-arrow-left"
      [outlined]="true"
      (onClick)="store.dispatch(actions.backButtonClicked())"
    />
  </div>
</ng-container>
